/**
 * 基于axios的请求方法
 */

import axios from "axios"
import queryString from "@/utils/queryString"
import { baseUrl, NETWORK_ERR_MSG } from "../config"
import store from "../store"

export const CancelToken = axios.CancelToken

// 使用这种类型必须对参数序列化，使用utils.queryString
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
// axios.defaults.headers.common["Content-Type"] = "application/json"

axios.defaults.baseURL = baseUrl

const http = {
  post({ url = "", params = {}, headers = {}, onUploadProgress = null, finalFunc = null, showLoading = true, showToast = true, interceptError = true, cancelToken = null } = {}) {
    return new Promise((resolve, reject) => {
      let config = {
        headers: {},
        cancelToken
      }
      const userUuid = store.state.userInfo.userInfo.userUuid || ""
      userUuid && (config.headers["Authorization"] = userUuid)
      headers && Object.assign(config.headers, headers)
      onUploadProgress && (config.onUploadProgress = onUploadProgress)
      showLoading && store.commit("loading/showLoading")
      if (params && typeof params === "object") {
        params = queryString(params)
      }
      axios
        .post(url, params, config)
        .then(res => {
          finalFunc && finalFunc()
          if (interceptError) {
            if (res.data && res.data.code === 200) {
              resolve(res.data.data)
            } else {
              showToast && store.commit("toast/showToast", res.data.msg || NETWORK_ERR_MSG)
              reject(res.data.msg || NETWORK_ERR_MSG)
            }
          } else {
            resolve(res.data)
          }
          showLoading && store.commit("loading/hideLoading")
        })
        .catch(err => {
          finalFunc && finalFunc()
          if (!err.__CANCEL__) {
            showToast && store.commit("toast/showToast", NETWORK_ERR_MSG)
            showLoading && store.commit("loading/hideLoading")
          }
          reject(err)
        })
    })
  },
  get({ url = "", params = {}, headers = {}, finalFunc = null, onUploadProgress = null, showLoading = true, showToast = true, interceptError = true } = {}) {
    return new Promise((resolve, reject) => {
      if (params && typeof params === "object") {
        params = queryString(params)
      }
      let config = {
        headers: {
          accept: "application/json"
        }
      }
      const isGetShareSignInfo = url.indexOf("getShareSignInfo") > -1
      const userUuid = store.state.userInfo.userInfo.userUuid || ""
      if (!isGetShareSignInfo) {
        userUuid && (config.headers["Authorization"] = userUuid)
      }
      headers && Object.assign(config.headers, headers)
      params && (url = `${url}?${params}`)
      onUploadProgress && (config.onUploadProgress = onUploadProgress)
      showLoading && store.commit("loading/showLoading")
      axios
        .get(url, config)
        .then(res => {
          finalFunc && finalFunc()
          if (interceptError) {
            if (res.data && Number(res.data.code) === 200 && res.data.data) {
              resolve(res.data.data)
            } else {
              showToast && store.commit("toast/showToast", res.data.msg || NETWORK_ERR_MSG)
              reject(res.data.msg || NETWORK_ERR_MSG)
            }
          } else {
            resolve(res.data)
          }
          showLoading && store.commit("loading/hideLoading")
        })
        .catch(err => {
          finalFunc && finalFunc()
          showToast && store.commit("toast/showToast", NETWORK_ERR_MSG)
          showLoading && store.commit("loading/hideLoading")
          reject(err)
        })
    })
  }
}

export default http
